import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import LogoComponent from './chapters-logo-image-url.component';
import CoverimageComponent from './chapters-cover-image-url.component';

export const TopicsBasicInfoComponent = ({
    selectedChapters, handleInnerFormChange, chapters, changeCoverImage, changeLogoImage
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


                        <InputContainer
                            label="Community"
                            labelField="Name"
                            list={chapters}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CommunityId'
                                )
                            }}
                            optionName='Choose Chapter'
                            type="select"
                            value={selectedChapters?.CommunityId}
                            valueField="Id"
                        />



                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            type="text"
                            value={selectedChapters?.Name}
                        />


                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Description'
                                );
                            }}
                            type="text"
                            value={selectedChapters?.Description}
                        />

                        <InputContainer
                            label="Location"
                            name="Location"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Location'
                                );
                            }}
                            type="text"
                            value={selectedChapters?.Location}
                        />

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />

            <AccordionContainer
                child={
                    <div>
                        <LogoComponent
                            selectedChapters={selectedChapters}
                            changeLogoImage={changeLogoImage}
                        />

                    </div>
                }
                expandedPanel="logo"
                headerTitle="Logo Info"
            />

            <AccordionContainer
                child={
                    <div>
                        <CoverimageComponent
                            selectedChapters={selectedChapters}
                            changeCoverImage={changeCoverImage}
                        />

                    </div>
                }
                expandedPanel="Cover"
                headerTitle="CoverImage Info"
            />
        </>
    )
}

export default TopicsBasicInfoComponent;
